import { render, staticRenderFns } from "./LatencyMonitor.vue?vue&type=template&id=50f82bcb&scoped=true"
import script from "./LatencyMonitor.vue?vue&type=script&lang=js"
export * from "./LatencyMonitor.vue?vue&type=script&lang=js"
import style0 from "./LatencyMonitor.vue?vue&type=style&index=0&id=50f82bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f82bcb",
  null
  
)

export default component.exports